export default function ComparisonSection() {
  const rows = [
    { feature: "Content creation", manual: "2–4 hrs/day writing posts", clicksendai: "AI generates 100s of posts instantly" },
    { feature: "Multi-network posting", manual: "Log into each platform manually", clicksendai: "One click publishes to 30+ networks, sites & directories" },
    { feature: "Optimal timing", manual: "Guess and check, inconsistent", clicksendai: "AI picks best time per network automatically" },
    { feature: "Skool group analytics", manual: "No visibility into what drives members", clicksendai: "Full attribution — see which posts grow your group" },
    { feature: "Consistency", manual: "Burn out, miss days, lose momentum", clicksendai: "Posts every day, 24/7, even while you sleep" },
    { feature: "Cost", manual: "$3,000–$8,000/mo for a marketing team", clicksendai: "Starting at $19/mo — do it yourself with AI" },
    { feature: "Setup time", manual: "Weeks to hire and onboard", clicksendai: "Live in under 5 minutes" },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-rose-100 text-rose-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Why ClickSendAI
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Stop Doing It the{" "}
            <span className="line-through text-gray-300">Hard Way</span>
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            Manual Skool group marketing is exhausting and expensive. ClickSendAI automates everything so you can focus on your community.
          </p>
        </div>

        <div className="rounded-2xl border border-gray-100 overflow-hidden">
          {/* Header */}
          <div className="grid grid-cols-3 bg-gray-50 border-b border-gray-100">
            <div className="p-4 text-xs font-semibold text-gray-400 uppercase tracking-wider">Feature</div>
            <div className="p-4 text-xs font-semibold text-gray-500 uppercase tracking-wider border-l border-gray-100 flex items-center gap-2">
              <i className="ri-user-line text-gray-400"></i> Manual Marketing
            </div>
            <div className="p-4 text-xs font-semibold uppercase tracking-wider border-l border-violet-100 bg-violet-50 text-violet-700 flex items-center gap-2">
              <i className="ri-robot-2-line text-violet-500"></i> ClickSendAI AI
            </div>
          </div>

          {rows.map((row, i) => (
            <div
              key={row.feature}
              className={`grid grid-cols-3 border-b border-gray-50 last:border-0 ${i % 2 === 0 ? "bg-white" : "bg-gray-50/50"}`}
            >
              <div className="p-4 text-sm font-semibold text-gray-700">{row.feature}</div>
              <div className="p-4 text-sm text-gray-500 border-l border-gray-100 flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-close-line text-rose-400 text-sm"></i>
                </div>
                {row.manual}
              </div>
              <div className="p-4 text-sm text-violet-700 border-l border-violet-100 bg-violet-50/30 flex items-start gap-2 font-medium">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-check-line text-emerald-500 text-sm"></i>
                </div>
                {row.clicksendai}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
